import {
  createMultiStyleConfigHelpers,
  StyleThemingProps,
} from '@chakra-ui/react'
import { textStyleKeys } from '~/themes/textStyles'
import { useCustomMultiStyleConfig } from '~/utils/chakraUtils'
import { getName } from '~/utils/objectUtils'

export const ParkCallMenuStyleValues = {
  containerWidth: '18.75rem',
  containerWidthPopup: '12.75rem',
}

const parkCallMenuParts = ['headerContainer', 'headerText'] as const

const helpers = createMultiStyleConfigHelpers(parkCallMenuParts)
export const ParkCallMenuStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    headerContainer: {
      width: 'full',
      paddingY: '0.5rem',
      paddingX: '0.75rem',
      borderRadius: '0.5rem',
      alignItems: 'center',
    },
    headerText: {
      userSelect: 'none',
      textStyle: textStyleKeys.Body3_Bold,
    },
  },
})

export const useParkCallMenuStyle = (props?: StyleThemingProps) => {
  return useCustomMultiStyleConfig<typeof parkCallMenuParts>(
    getName({ ParkCallMenuStyle }),
    props,
  )
}
